import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 28 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 24\" id=\"icon-arrow-right\"><path d=\"M28 12L17.6 24l-1.8-1.4-1.8-1.2 1.8-2 4.6-5.4H0V9.8h20.2l-4.4-5-1.8-2 1.8-1.4L17.6 0 28 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol